module.exports = __webpack_public_path__ + "img/icon_Image_05.cd89fc85.png";